import { Loader2 } from "lucide-react";
import { useTranslations } from "use-intl";
import { Button } from "@/components/ui/button";

/**
 * The save button and the "unsaved changes" hint at the foot of a settings card. The words are the
 * card's own `save`, `saving` and `unsaved` catalog entries under `namespace`; the behaviour —
 * disabled while loading, saving or unchanged, a spinner while saving, the hint only when there is
 * something to save — is the same everywhere.
 */
export function SaveSettingsBar({
  onSave,
  status: { loading, saving, hasChanges },
  namespace,
}: {
  onSave: () => void;
  status: { loading: boolean; saving: boolean; hasChanges: boolean };
  namespace: "consultantSettings.sellerInfo" | "consultantSettings.context";
}) {
  const t = useTranslations(namespace);

  return (
    <>
      <Button onClick={onSave} disabled={loading || saving || !hasChanges} className="w-full">
        {saving ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            {t("saving")}
          </>
        ) : (
          t("save")
        )}
      </Button>

      {hasChanges && !saving && <p className="text-sm text-amber-600">{t("unsaved")}</p>}
    </>
  );
}
